export const defaultAmountOfEntriesInPlaylistIndex = 20;
